module.exports = __webpack_public_path__ + "img/[叹气].f21d0258.svg";